import AppBar from '@/components/app-bar/AppBar.vue'
import AppBarSpace from '@/components/app-bar/AppBarSpace.vue'
import contestApi from '@/api/contest'

export default {
    name: 'PlayerIgnoreList',
    components: {
        AppBar,
        AppBarSpace,
    },
    data() {
        return {
            contestId: this.$route.params.contestId,
            keyword: '',
            ignoreList: this.$route.params.ignoreList,
            playerList:[],
            currentPlayerList:[],
            isLoading: false,
        }
    },
    created() {
        this.getAllPlayer()
    },
    beforeRouteLeave (to, from, next) {
        let ignoreList = []
        for (let i = 0; i < this.playerList.length; i++) {
            let player = this.playerList[i]
            if (player.unInclude) {
                console.log('unInclude')
                ignoreList.push(player)
            }
        }
        console.log(ignoreList)
        this.$route.params.ignoreList = ignoreList
        next()
    },
    watch: {
        keyword() {
            this.updateKeywordFilter()
        }
    },
    methods: {
        async getAllPlayer() {
            try {
                this.playerList = await contestApi.getIgnoreAllPlayer(this.contestId)
                for (let i = 0; i < this.ignoreList.length; i++) {
                    for (let j = 0; j < this.playerList.length; j++) {
                        if(this.ignoreList[i].playerId === this.playerList[j].playerId){
                            this.playerList[j].unInclude = true
                            break
                        }
                    }
                }
                this.updateKeywordFilter()
                this.isLoading = false
            } catch (error) {
                this.isLoading = false
                this.$toast.fail(error.message)
            }
        },
        updateKeywordFilter() {
            this.currentPlayerList = this.filterKeywordList(this.keyword,this.playerList)
        },
        filterKeywordList(keyword, array) {
            let list = []
            for (let i = 0; i < array.length; i++) {
                let player = array[i]
                if (!keyword || keyword === '' || player.playerName.indexOf(keyword) >= 0 || player.playerPhone.indexOf(keyword) >= 0) {
                    list.push(player)
                }
            }
            return list
        },
        clearKeyword() {
            this.keyword = ''
        },
        ignoreAction(index,player){
            player.unInclude = !player.unInclude
            this.$set(this.currentPlayerList,index,player)
        },
    }
}
